import React from 'react';

interface GoogleIconProps {
  width?: number | string;
  height?: number | string;
  className?: string;
}

const GoogleIcon: React.FC<GoogleIconProps> = ({ width = 18, height = 18, className }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M3.98933 10.8783L3.36275 13.2174L1.07262 13.2659C0.388209 11.9964 0 10.544 0 9.00062C0 7.50814 0.362966 6.10072 1.00635 4.86145L3.0457 5.23524L3.93884 7.26187C3.75191 7.80684 3.65002 8.39186 3.65002 9.00062C3.65009 9.6613 3.76977 10.2943 3.98933 10.8783Z"
        fill="#FBBB00"
      />
      <path
        d="M17.843 7.31909C17.9463 7.86354 18.0002 8.42582 18.0002 9.00047C18.0002 9.64483 17.9325 10.2734 17.8034 10.8797C17.3653 12.9428 16.2204 14.7444 14.6345 16.0192L12.066 15.8877L11.7025 13.6188C12.7549 13.0017 13.5773 12.0359 14.0105 10.8797H9.19775V7.31909H17.843Z"
        fill="#518EF8"
      />
      <path
        d="M14.6355 16.0185C13.0931 17.2582 11.1343 18.0005 9.00144 18.0005C5.57389 18.0005 2.59391 16.0848 1.07373 13.2655L3.99043 10.8779C4.7505 12.9064 6.70734 14.3505 9.00144 14.3505C9.9875 14.3505 10.9113 14.0839 11.704 13.6186L14.6355 16.0185Z"
        fill="#28B446"
      />
      <path
        d="M14.7445 2.07204L11.8288 4.4591C11.0084 3.94629 10.0386 3.65005 8.99959 3.65005C6.65357 3.65005 4.66083 5.16061 3.93884 7.26187L1.00635 4.86145C2.50427 1.97344 5.52111 0 8.99959 0C11.1834 0 13.1857 0.777895 14.7445 2.07204Z"
        fill="#F14336"
      />
    </svg>
  );
};

export default GoogleIcon;
